<template>
  <div class="cast-screen" @mousemove="onMouseMove">
    <video
      class="video"
      src="/video/序列 02.mp4"
      @playing="onPlaying"
      @play="onPlay"
      autoplay
      muted
      loop
    ></video>
    <Screen1 class="screen" ref="screen-1" v-show="currentScreen === 1" />
    <Screen2 class="screen" ref="screen-2" v-show="currentScreen === 2" />
    <Screen3 class="screen" ref="screen-3" v-show="currentScreen === 3" />
    <Screen4 class="screen" ref="screen-4" v-show="currentScreen === 4" />

    <ScreenBack class="back animated fadeInRight" @click.native="onBack" v-show="backShow" />
  </div>
</template>

<script>
import Screen1 from "@/components/castscreen/Screen1";
import Screen2 from "@/components/castscreen/Screen2";
import Screen3 from "@/components/castscreen/Screen3";
import Screen4 from "@/components/castscreen/Screen4";
import ScreenBack from "@/components/castscreen/ScreenBack";

export default {
  name: "CastScreen",
  components: {
    Screen1,
    Screen2,
    Screen3,
    Screen4,
    ScreenBack
  },
  data() {
    return {
      currentScreen: 0,
      backShow: false,
      lastBackShowTime: 0,
      playStart: false
    };
  },
  mounted() {},
  methods: {
    onBack() {
      this.$router.push("/");
    },
    onMouseMove() {
      this.backShow = true;
      this.lastBackShowTime = Date.now();

      setTimeout(() => {
        if (Date.now() - this.lastBackShowTime >= 2000) {
          this.backShow = false;
        }
      }, 2000);
    },
    onPlaying() {
      this.playStart = true;

      setTimeout(() => {
        this.playStart = false;
      }, 100);
    },
    onPlay() {
      this.play();
    },
    async playing() {
      return new Promise((resolve, reject) => {
        const interval = setInterval(() => {
          if (this.playStart) {
            this.playStart = false;

            clearInterval(interval);
            resolve();
          }
        }, 100);
      });
    },
    async sleep(duration) {
      return new Promise((resolve, reject) => {
        setTimeout(resolve, duration);
      });
    },
    async playScreen1() {
      this.currentScreen = 1;
      await this.$refs["screen-1"].slideInUp();
      await this.sleep(3000);
      await this.$refs["screen-1"].slideOutUp();
      this.currentScreen = -1;
    },
    async playScreen2() {
      this.currentScreen = 2;
      await this.$refs["screen-2"].slideInUp();
      await this.sleep(3000);
      await this.$refs["screen-2"].slideOutUp();
      this.currentScreen = -1;
    },
    async playScreen3() {
      this.currentScreen = 3;
      await this.$refs["screen-3"].slideInUp();
      await this.sleep(3000);
      await this.$refs["screen-3"].slideOutUp();
      this.currentScreen = 0;
    },
    async playScreen4() {
      this.currentScreen = 4;
      await this.$refs["screen-4"].slideInUp();
      await this.sleep(3000);
      await this.$refs["screen-4"].slideOutUp();
      this.currentScreen = 0;
    },
    async play() {
      await this.playScreen1();
      await this.playing();
      await this.playScreen2();
      await this.sleep(2000);
      await this.playScreen3();
      await this.sleep(2000);
      await this.playScreen4();
      await this.playing();
      this.play();
    }
  }
};
</script>

<style lang="scss">
.cast-screen {
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .video {
    object-fit: fill;
    position: fixed;
    top: 0;
    z-index: 1;
  }

  .screen {
    z-index: 2;
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    background: rgba(0, 0, 0, 0.9);
  }

  .back {
    position: fixed;
    top: 70px;
    right: 70px;
    z-index: 9;
  }
}
</style>